"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var Chart_1 = __importDefault(require("../Chart"));
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var DonutChart = function (_a) {
    var data = _a.data, size = _a.size, tooltipFormatter = _a.tooltipFormatter, _b = _a.sharedTooltip, sharedTooltip = _b === void 0 ? false : _b, _c = _a.legendVerticalAlign, legendVerticalAlign = _c === void 0 ? 'top' : _c, _d = _a.legendHorizontalAlign, legendHorizontalAlign = _d === void 0 ? 'right' : _d, _e = _a.legendLayout, legendLayout = _e === void 0 ? 'vertical' : _e, legendWidth = _a.legendWidth, props = __rest(_a, ["data", "size", "tooltipFormatter", "sharedTooltip", "legendVerticalAlign", "legendHorizontalAlign", "legendLayout", "legendWidth"]);
    var options = react_2.useMemo(function () {
        return utils_1.getOptions({
            data: data,
            size: size,
            tooltipFormatter: tooltipFormatter,
        });
    }, [data, size, tooltipFormatter]);
    return (react_1.jsx(Chart_1.default, __assign({ options: options, sharedTooltip: sharedTooltip }, props, { legendHorizontalAlign: legendHorizontalAlign, legendVerticalAlign: legendVerticalAlign, legendLayout: legendLayout, legendWidth: legendWidth })));
};
DonutChart.SIZES = constants_1.SIZES;
exports.default = DonutChart;
